const sendReports = reports => {
  const filteredReports = reports.filter(report =>
    !(report.type === 'deprecation' && report.body.id === 'UnloadHandler')
  )

  if (filteredReports.length)
    navigator.sendBeacon('/browser_reports', JSON.stringify(filteredReports))
}

const init = () => {
  const observer = new ReportingObserver(sendReports, {
    buffered: true,
    types: [ 'deprecation', 'intervention' ],
  })
  observer.observe()

  const sendPendingReports = () => sendReports(observer.takeRecords())

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden')
      sendPendingReports()
  })

  addEventListener('pagehide', sendPendingReports)
}

if (typeof ReportingObserver !== 'undefined') init()
